// payment status
export const COMPLETED = 'Completed';
export const CANCELLED = 'Cancelled';
export const PENDING = 'Pending';
export const OVERDUE = 'Overdue';

export const paymentCompletionStatus = [
  {
    id: 1, 
    status: "Completed"
  },
  {
    id: 1, 
    status: "Partial"
  }
]

export const paymentMethod = [
  {
    id: 1, 
    title: "Online"
  },
  {
    id: 1, 
    title: "Bank"
  },
  {
    id: 1, 
    title: "Cash"
  }
]